import { ConfigFilterItem } from 'Core/interfaces/filters'

export enum AccrualFilterFields {
	archive = 'archiveCode'
}

export declare namespace Accrual {
	interface Basic {
		fileName: string
		archive: NameCode | null
	}

	namespace Filters {
		interface Config {
			[AccrualFilterFields.archive]: ConfigFilterItem<string, string>
		}
	}
}
